module.exports = __webpack_public_path__ + "static/img/3.4633753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-vida/3.png
// module id = nUba
// module chunks = 0